import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { useFeatureFlag } from 'features/user/hooks/useFeatureFlag'
import { fromDTO } from './api/mapper'
import { GET_AB_TEST } from './api/query'

import type { AbTestSlice, UseGet, UseGetProps } from './types'

export const useGetAbTest = ({ id }: UseGetProps): UseGet => {
  const [abTest, setAbTest] = useState<AbTestSlice | undefined>()

  const { isFeatureEnabled: withYp2395 } = useFeatureFlag('yp2395AbTestsDivideTraffic')

  const { loading } = useQuery(GET_AB_TEST({ withYp2395 }), {
    onCompleted: ({ node: abTest }): void => {
      if (abTest) {
        setAbTest(fromDTO({ withYp2395, ...abTest }))
      }
    },
    variables: { id },
  })

  return { abTest, loading }
}
